module.exports = __webpack_public_path__ + "img/1.821d817b.webp";